/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const DateClaimValue: core.serialization.ObjectSchema<serializers.DateClaimValue.Raw, Truvity.DateClaimValue> =
    core.serialization.object({
        value: core.serialization.string(),
    });

export declare namespace DateClaimValue {
    export interface Raw {
        value: string;
    }
}
